import React from 'react';
import styled from 'styled-components';
import useTranslation from '@src/hooks/useTranslation';

import CoursePrice from '@src/components/course/basicInfo/courseCard/courseDetail/coursePrice';
import { ICourse } from '@src/types/course';
import { CURRENCY_SYMBOL } from '@src/const/common';
import { formatPrice } from '@src/utils/price';

const ButtonWrapper = styled.div`
	.course-price__cta-button {
		height: 48px;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;

		${({ status, paid }: {
		status: string;
		paid: boolean;
	}) => {
		if (status === 'preparing' && paid) {
			return `
					border: 1px solid #9C9C9C !important;
				`;
		}
		return null;
	}}
	}

	.course-price__price {
		display: none;
	}

	.course-price__course-price-wrapper {
		grid-template-columns: 1fr;
	}
`;

const discountStyle = {
	color: '#FFFFFF',
	fontSize: 20,
};

const InitPrice = styled.div`
	font-size: 14px;
	color: #a0a0a0;
	text-decoration: line-through;
	margin: 16px 0px 8px;

  visibility: ${props => (props.$isVisible ? 'visible' : 'hidden')};

	span {
		margin-right: 4px;
	}
`;

const Label = styled.div`
	color: #676767;
	font-size: 14px;
`;

const CourseTitle = styled.div`
	font-size: 14px;
	font-weight: 500;
	color: #333;
	margin-top: 8px;
`;

const BasicCardWrapper = styled.div`
	border: 1px solid #DDDDDD;
	padding: 16px;
	background: #FFF;
`;

interface IProps {
	course: ICourse;
}

const BasicCard = ({ course }: IProps): JSX.Element => {
	const { t } = useTranslation();
	const { title, paid, status, subtotal_price, init_price, hide_price } = course;
	const showPrice = !(hide_price === true);
	let cta = `${t('course:add_to_cart')}`;
	if (showPrice) {
		cta = `${cta} ${CURRENCY_SYMBOL} ${formatPrice(subtotal_price)}`;
	}
	return (
		<BasicCardWrapper>
			<div className="basic-card__course-name-wrapper">
				<Label>{`${t('recommended_card:plan_contains')}：`}</Label>
				<CourseTitle>{title}</CourseTitle>
			</div>
			{
				showPrice && (
					<InitPrice $isVisible={!!init_price}>
						<span>{t('course:initial_price')}</span>
						{`${CURRENCY_SYMBOL} ${formatPrice(init_price)}`}
					</InitPrice>
				)
			}
			<ButtonWrapper status={status} paid={paid}>
				<CoursePrice
					showInitPrice={false}
					discountStyle={discountStyle}
					isCardStyle
					isNavbarStyle
					ctaText={(paid || formatPrice(subtotal_price) <= 0) ? null : cta}
				/>
			</ButtonWrapper>
		</BasicCardWrapper>
	);
};

export default BasicCard;
